export const normalizeAuthorTopics = (topics: readonly (string | null | undefined)[] | null | undefined): string[] => {
  if (!Array.isArray(topics)) return [];

  const seen = new Set<string>();
  const normalized: string[] = [];

  for (const topic of topics) {
    const value = typeof topic === 'string' ? topic.replace(/\s+/g, ' ').trim() : '';
    if (!value) continue;
    const key = value.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    normalized.push(value);
  }

  return normalized;
};

export const authorTopicHref = (topic: string): string => `/search?q=${encodeURIComponent(topic)}`;
